<template>
    <RefinementForm :refinement="refinement" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import RefinementForm from './RefinementForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    RefinementForm
  },
  data() {
    return {
      refinement:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.refinement=await APIRequest.detail('refinements',this.$route.params.id)
    this.loaded=true
  }
}
</script>
